import { render, staticRenderFns } from "./ProfilePasswordPage.vue?vue&type=template&id=138385ae&scoped=true&"
import script from "./ProfilePasswordPage.vue?vue&type=script&lang=js&"
export * from "./ProfilePasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138385ae",
  null
  
)

export default component.exports